import { cn } from "@/lib/utils";

export type CopilotStatus = "critical" | "warning" | "healthy" | "neutral";

const dotColors: Record<CopilotStatus, string> = {
  critical: "bg-copilot-critical",
  warning: "bg-copilot-warning",
  healthy: "bg-copilot-healthy",
  neutral: "bg-copilot-neutral",
};

interface StatusDotProps {
  status: CopilotStatus;
  size?: "sm" | "md";
  className?: string;
}

export function StatusDot({ status, size = "md", className }: StatusDotProps) {
  return (
    <span
      className={cn(
        "rounded-full shrink-0",
        size === "sm" ? "w-2 h-2" : "w-2.5 h-2.5",
        dotColors[status],
        className
      )}
      aria-label={`Status: ${status}`}
    />
  );
}
